import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { NgOptionTemplateDirective } from '@ng-select/ng-select';
import { ButtonComponent, CardComponent, CardGroupComponent, FormGroupComponent } from 'mbs-ui-kit';
import { PasswordRecoveryHandlerComponent } from 'mbs-ui-shared@modules/password-recovery/components/password-recovery-handler/password-recovery-handler.component';
import { UtilsPipeModule } from 'mbs-ui-shared@utils/utils.pipe.module';
import { GenericRestoreFromToStepComponent } from 'wizards/steps/only-restore-steps/generic-restore-steps/generic-restore-from-to-step/generic-restore-from-to-step.component';
import { GenericWhatToRestoreStepComponent } from 'wizards/steps/only-restore-steps/generic-restore-steps/generic-what-to-restore-step/generic-what-to-restore-step.component';

const steps = [GenericRestoreFromToStepComponent, GenericWhatToRestoreStepComponent];

@NgModule({
  imports: [
    CardComponent,
    CardGroupComponent,
    ButtonComponent,
    FormGroupComponent,
    ReactiveFormsModule,
    FormsModule,
    NgOptionTemplateDirective,
    UtilsPipeModule,
    NgbTooltip,
    PasswordRecoveryHandlerComponent,
    ...steps
  ],
  exports: [...steps]
})
export class GenericRestoreStepsModule {}
